Ext.define('SA.view.TableController', {
    constructor({state, renderer, topHeader, leftHeader, body, loadMask}) {
        this.state = state;
        this.renderer = renderer;
        this.topHeader = topHeader;
        this.leftHeader = leftHeader;
        this.body = body;
        this.loadMask = loadMask;

        this.everRendered = false;
    },

    clearDragColId() {
        this.state.clearDragColId();
    },

    getTrackIds() {
        return this.state.getTrackIds();
    },

    hideLoadMask() {
        this.loadMask.hide();
    },

    moveColIdAfter(moveColId, afterColId) {
        var trackIds = this.getTrackIds().moveColIdAfter(moveColId, afterColId);
        this.setTrackIds(trackIds);
    },

    moveColIdBefore(moveColId, beforeColId) {
        var trackIds = this.getTrackIds().moveColIdBefore(moveColId, beforeColId);
        this.setTrackIds(trackIds);
    },

    onScrollBody() {
        if (this.state.isDragging() || this.topHeader.isHovered() || this.leftHeader.isHovered()) {
            return;
        }

        this.topHeader.setScrollLeft(this.body.getScrollLeft());
        this.leftHeader.setScrollTop(this.body.getScrollTop());
        this.render();
    },

    onScrollLeftHeader() {
        if (this.state.isDragging() || this.body.isHovered()) {
            return;
        }

        this.body.setScrollTop(this.leftHeader.getScrollTop());
        this.render();
    },

    onScrollTopHeader() {
        if (this.state.isDragging() || this.body.isHovered()) {
            return;
        }

        this.body.setScrollLeft(this.topHeader.getScrollLeft());
        this.render();
    },

    render() {
        this.everRendered = true;

        this.renderer.render(this.state);
    },

    scrollLeftBy(amount) {
        this.topHeader.scrollLeftBy(amount);
        this.body.scrollLeftBy(amount);
    },

    scrollRightBy(amount) {
        this.topHeader.scrollRightBy(amount);
        this.body.scrollRightBy(amount);
    },

    setContainerSize(containerSize) {
        this.state.setContainerSize(containerSize);
    },

    setDragColId(dragColId) {
        this.state.setDragColId(dragColId);
    },

    setTrackIds(trackIds) {
        this.state.setTrackIds(trackIds);
    },

    showLoadMask() {
        if (!this.everRendered) {
            return;
        }

        this.loadMask.show();
    }
});